// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1BszV","select":"Header_select__3Ujq0","clinic":"Header_clinic__3w2lb"};